import { Tee } from '@/types/golf';
import { IonContent, IonItem, IonList, IonPage } from '@ionic/react';
import TeeBadge from './TeeBadge';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TeeSelectionPageProps {
  nav: HTMLIonNavElement;
  tees: Tee[];
  selectedTee: Tee;
  onSelectTee: (tee: Tee) => void;
}

const TeeSelectionPage: React.FC<TeeSelectionPageProps> = ({
  nav,
  tees,
  selectedTee,
  onSelectTee
}) => {
  const { t } = useTranslation();

  const handleSelectTee = (tee: Tee) => {
    nav.pop();
    onSelectTee(tee);
  };

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <IonList className="rounded-lg overflow-hidden">
          {
            tees.map((tee) => {
              return (
                <IonItem
                  key={tee.teeId}
                  button
                  detail={false}
                  onClick={() => handleSelectTee(tee)}
                >
                  <div className="flex items-center justify-between w-full py-3">
                    <div className="flex items-center gap-3">
                      <TeeBadge teeName={tee.teeName} size="md" />
                      <div>
                        <div className="font-medium">{t(tee.teeName)} ({tee.totalDistance} m)</div>
                        <div className="text-xs text-gray-500">
                          CR: {tee.courseCr} SR: {tee.courseSlope}
                        </div>
                      </div>
                    </div>
                    {selectedTee === tee && (
                      <div className="size-4 rounded-full bg-primary"></div>
                    )}
                  </div>
                </IonItem>
              );
            })
          }
        </IonList>
      </IonContent>
    </IonPage >
  );
};

export default TeeSelectionPage;
